export default {
    namespaced: true,
    state: {
        menuslist:[]
    },
    mutations: {
    setMenuslist(state, payload) {
        state.menuslist = payload
    },
    },


}